module.exports = __webpack_public_path__ + "ad52f765425506cea9632104b3c18a8e.jpg";